module.exports = __webpack_public_path__ + "img/weixin.31e98180.png";